import { useMutation } from '@tanstack/react-query';
import type { FileUploadCleanupRequest } from '../../../Domain/Admin/Services';
import { adminServices } from '../../../Domain/Admin/Services';

const mutationFn = (data: FileUploadCleanupRequest) => {
  return adminServices.undoUploadedFileExecute(data);
};

export const useFileUploadCleanupExecuteMutation = () => {
  return useMutation<unknown, unknown, FileUploadCleanupRequest>(mutationFn);
};
